export enum Pages {
  FILE_UPLOAD_PAGE = 0,
  EDIT_ENTRIES_PAGE = 1,
  REVIEW_PAGE = 2,
}

/** The existing AI submission wizard has no file upload page. */
export enum AiSubmissionPages {
  EDIT_ENTRIES_PAGE = 0,
  REVIEW_PAGE = 1,
}
